export default "__VITE_ASSET__B549T9g___"